import React from 'react';
import { StarIcon } from 'lucide-react';
import { coaches } from '../data/coaches';
export function RatingProof() {
  const faces = coaches.slice(0, 5);
  return <div className="flex items-center gap-3" data-id="element-243" data-mp="36p4ricr6smu7">
      <div className="flex -space-x-2.5" data-id="element-244" data-mp="3bpj2a2k6aavx">
        {faces.map(coach => <img key={coach.name} src={coach.avatar} alt={coach.name} width={36} height={36} className="h-9 w-9 rounded-full object-cover ring-2 ring-plum-deep" data-id="element-245" data-mp="3gh0ua147x14r" />)}
      </div>
      <div className="leading-tight" data-id="element-246" data-mp="3pk1vpoi52423">
        <div className="flex items-center gap-0.5" aria-hidden="true" data-id="element-247" data-mp="3ugk02n9k40dw">
          {[0, 1, 2, 3, 4].map(s => <StarIcon key={s} className="h-3.5 w-3.5 fill-gold text-gold" data-id="element-248" data-mp="3b0lncg61n0p" />)}
        </div>
        <p className="mt-1 whitespace-nowrap text-[13px] text-white/75" data-id="element-249" data-mp="2042i9v7hlsgn">
          <span className="font-semibold text-white" data-id="element-250" data-mp="251vk6c1rc0b4">4.9/5</span> from 1,200+
          teachers
        </p>
      </div>
    </div>;
}